export default (editor) => {
  const { value } = editor;

  if (editor) {
    const { fragment, selection } = value;

    if (fragment) {
      const { nodes: fragmentNodes } = fragment;
      const anchorFragment = fragmentNodes.toArray()[0];

      if (anchorFragment) {
        const childNodes = anchorFragment.nodes.toArray();

        if (childNodes && childNodes[0].nodes) {
          if (childNodes && childNodes[0]) {
            const fields = childNodes[0].nodes.toArray();

            if (
              fields.length > 1 ||
              (fields[0].type === 'education_cgpa' &&
                selection.start.key !== selection.end.key)
            ) {
              editor.moveToAnchor();
            }
          }
        }
      }
    }
  }
};
